import React, {Component} from 'react';
import styled from "styled-components";
import PropTypes from 'prop-types';

const ContentWrapper = styled.div`
    display: inline-block;
    margin: 0;
`;

const EditText = styled.input`
    padding: 0.15rem 0.25rem;
    margin-left: 0.25rem;
`;

const DEFAULT_SIZE = 20;

export class SimpleInputText extends Component {

    static propTypes = {
        initial_value: PropTypes.string,
        on_change: PropTypes.func.isRequired,
        size:PropTypes.number
    }

    static defaultProps = {
        size: DEFAULT_SIZE
    }

    render() {
        return <ContentWrapper>
            <EditText
                type={"text"}
                size={this.props.size}
                value={this.props.initial_value}
                onChange={evt => this.props.on_change(evt)}/>
        </ContentWrapper>
    }
}

export default SimpleInputText;

